<template>
  <div class="combo-section" :class="{ border, [direction]: true }">
    <slot name="header" v-bind="innerScope"></slot>
    <div class="section__body">
      <c-form-items v-bind="formItemsAttrs" :model="model"></c-form-items>
    </div>
    <slot name="footer" v-bind="innerScope"></slot>
  </div>
</template>

<script setup lang="ts">
import { _, tpl, computed, useCurrentAppInstance } from '@zto/zpage'

import { ComboFormItem } from './types'

const app = useCurrentAppInstance()

// 属性
const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    modelIndex: number // 模块属性

    items: ComboFormItem[] | Function
    itemsAttrs?: any
    exFormRules?: any[] // 扩展规则

    editable?: boolean // 是否可编辑
    disabled?: boolean // 是否disable编辑

    direction?: string // column/row
    border?: boolean
  }>(),
  {
    data: () => [],
    items: () => [],
    noIndex: false,
    noOperation: false,

    editable: false,

    border: true,
    direction: 'column'
  }
)

/** 内部scope */
const innerScope = computed(() => {
  return {
    $index: props.modelIndex,
    comboModel: props.model,
    model: props.model.data[props.modelIndex]
  }
})

/** 表单项属性 */
const formItemsAttrs = computed(() => {
  let items: any[] = []

  const context = app.useContext(innerScope.value)

  if (typeof props.items === 'function') {
    items = props.items(context)
  } else {
    items = props.items
  }

  const formItems = items.map(it => {
    let item: any = it || {}

    if (typeof item === 'function') {
      item = item(context)
    }

    const itProp = `data.${props.modelIndex}.${it.prop}`

    item = { ...item, prop: itProp }

    if (item.comboDynamicAttrs) {
      const _dynamicAttrs = item.comboDynamicAttrs(context, item)
      item = { ...item, ..._dynamicAttrs }
    }

    return item
  })

  return {
    showOperation: false,
    items: formItems,
    ...props.itemsAttrs
  }
})
</script>

<style scoped lang="scss">
.combo-section {
  display: flex;
  flex-direction: column;

  &.row {
    flex-direction: row;
  }

  &.row-reverse {
    flex-direction: row-reverse;
  }

  &.column-reverse {
    flex-direction: column-reverse;
  }

  &.border {
    border: 1px dotted var(--border-color);
    padding: 10px;
    border-radius: 5px;
  }

  .section__body {
    flex: 1;
  }
}
</style>
